<template>
  <div id="app">
      <router-view>
      </router-view>

  </div>
</template>

<script>
export default {
  data(){
    return{
      data:[]
    }
  },
  created(){
  },
  mounted(){

  },
  methods: {
    gotoAddress(path){
      this.$router.push(path)
    }
  },

}
</script>



<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>



// WEBPACK FOOTER //
// App.vue?36667b5d